"use client";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";

import enUS from "@src/locales/en-US.json";
import jaJP from "@src/locales/ja-JP.json";
import zhCN from "@src/locales/zh-CN.json";

const DEFAULT_LOCALE = "en-US";

// 受支持的语言目录（新增语言：加一个 JSON 文件并在此登记）
const MESSAGES: Record<string, Record<string, string>> = {
  "en-US": enUS,
  "zh-CN": zhCN,
  "ja-JP": jaJP
};

// 把浏览器 locale（如 "zh"、"zh-TW"、"ja"、"en-GB"）归一到受支持的目录键
function resolveLocale(input?: string): string {
  if (!input) return DEFAULT_LOCALE;
  if (MESSAGES[input]) return input;
  const lang = input.toLowerCase().split("-")[0];
  if (lang === "zh") return "zh-CN";
  if (lang === "ja") return "ja-JP";
  if (lang === "en") return "en-US";
  return DEFAULT_LOCALE;
}

type Props = {
  children?: ReactNode;
};

export const CustomIntlProvider: React.FunctionComponent<Props> = ({ children }) => {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);

  useEffect(() => {
    if (navigator?.language) {
      setLocale(resolveLocale(navigator.language));
    }
  }, []);

  return (
    <IntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE} messages={MESSAGES[locale]}>
      {children}
    </IntlProvider>
  );
};
